export default __webpack_public_path__ + "static/logo-c8ae55b20940f8135b6b42bea12ac745.png";